export const LOOKUP_STATUS = {
    SUCCESS: 'success',
    PENDING: 'pending',
    FAILURE: 'failure',
};
